export default {"src":"/_next/static/media/KeepaTypeFaBlue.e060110b.svg","height":36,"width":55};